import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales, Language } from 'assets/locales/Locale';
import { compact, uniq, values } from 'lodash';
import ProductEnhancement from 'models/productManagement/productEnhancement/Model.ProductEnhancement';
import React, { useMemo } from 'react';
import { useDealerProvider } from '../../Dealer.Hooks';
import ProductEnhancementDocumentTranslation from './Dealer.ProductEnhancementDocumentTranslation';
import { Fragment } from 'react';

const DealerProductEnhancementDocumentForm: React.FC<{
  additionalProductEnhancementIds: number[];
  setAdditionalProductEnhancementIds: React.Dispatch<React.SetStateAction<number[]>>;
}> = ({ additionalProductEnhancementIds }) => {
  const { selected } = useDealerProvider();
  const { lang } = getLocales();

  const productEnhancementIds = useMemo(() => {
    const ids = uniq([...compact(selected?.productEnhancements?.map((p) => p.id)), ...additionalProductEnhancementIds]);
    return ids.length ? ids : undefined;
  }, [selected?.productEnhancements, additionalProductEnhancementIds]);
  const { payload: productEnhancementsPayload } = useApi(
    {
      action: ProductEnhancement.list,
      wait: !productEnhancementIds,
      body: {
        id: productEnhancementIds,
      },
    },
    [productEnhancementIds]
  );
  const productEnhancements = productEnhancementsPayload?.data;

  return (
    <>
      <table className={ThemeTableSimple}>
        <DataMap
          data={productEnhancements}
          render={({ data: product }) =>
            !product.productEnhancementDocuments.length ? null : (
              <Fragment key={product.id}>
                <thead>
                  <tr>
                    <th>{product.name}</th>
                    <DataMap
                      data={values(Language)}
                      render={({ data: langIsoCode }) => <th key={langIsoCode}>{lang[langIsoCode]}</th>}
                    />
                  </tr>
                </thead>
                <tbody>
                  <DataMap
                    data={product.productEnhancementDocuments}
                    render={({ data: productEnhancementDocument }) => {
                      return (
                        <tr key={productEnhancementDocument.id}>
                          <td>{productEnhancementDocument.displayInfo.title}</td>
                          <DataMap
                            data={values(Language)}
                            render={({ data: languageIsoCode }) => (
                              <td key={languageIsoCode}>
                                <ProductEnhancementDocumentTranslation
                                  languageIsoCode={languageIsoCode}
                                  productEnhancementDocument={productEnhancementDocument}
                                />
                              </td>
                            )}
                          />
                        </tr>
                      );
                    }}
                  />
                </tbody>
              </Fragment>
            )
          }
        />
      </table>
    </>
  );
};
export default DealerProductEnhancementDocumentForm;
